<div>
  <h3>Hol dir die fan.at App!</h3>
  <p>
    Um fan.at mit allen Vorteilen (z.B.: Benachrichtigungen, Tipp- und Gewinnspiele, Reporter etc.) bestmöglich genießen
    zu können, lade dir doch unsere App herunter.
  </p>
  <div class="store-items">
    <a [href]="playStoreLink" target="_blank">
      <img class="store-item" [src]="playStoreIcon" alt="Google Play Store">
    </a>
    <a [href]="appStoreLink" target="_blank">
      <img class="store-item last" [src]="appStoreIcon" alt="Apple App Store">
    </a>
  </div>
</div>
